import {
  type ValidationPasswordProps,
  type ValidationPasswordResponse,
} from "../contract";

const MIN_PASSWORD_LENGTH = 7;
const TRANSLATION_PATH = "auth.form.password.error";

const hasEnoughLength = (password: string): boolean =>
  password.length >= MIN_PASSWORD_LENGTH;
const hasLetters = (password: string): boolean =>
  /(?=.*[a-zA-Z])/.test(password);
const hasNumbers = (password: string): boolean => /(?=.*\d)/.test(password);

/* WITH MORE SPECIFIC VALUES
const validations = [
    { key: 'length', test: hasEnoughLength }, 
    { key: 'letters', test: hasLetters },
    { key: 'numbers', test: hasNumbers }
]
*/
const validations: ValidationPasswordProps[] = [
  { key: "format", test: hasEnoughLength },
  { key: "format", test: hasLetters },
  { key: "format", test: hasNumbers },
];

const isIncluded = (list: string[], key: string): boolean =>
  list.includes(`${TRANSLATION_PATH}.${key}`);

export const validatePassword = (
  password: string,
): ValidationPasswordResponse =>
  validations.reduce(
    (acc: ValidationPasswordResponse, validation: ValidationPasswordProps) => {
      const { key, test } = validation;
      const currentValidation = test(password);

      if (!currentValidation && !isIncluded(acc.errors, key)) {
        acc.errors.push(`${TRANSLATION_PATH}.${key}`);
      }

      return {
        errors: acc.errors,
        value: !acc.errors.length,
      };
    },
    { errors: [], value: true },
  );
